import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=a8295cb0&scoped=true"
import script from "./GroupView.vue?vue&type=script&lang=js"
export * from "./GroupView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8295cb0",
  null
  
)

export default component.exports